import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

function createIntegratedFeedback(feedbackObj) {
  return MessageBroker.send(RequestUrls.createIntegratedFeedback, feedbackObj);
}

export default { createIntegratedFeedback };
